import gql from 'graphql-tag';

const GET_SIGNUPS_V2_WITH_EVENTS_EXPORT = gql`
  query GetSignupsV2WithEventsExport(
    $campaignOrderId: ID!
    $startDate: String
    $endDate: String
    $attrMethod: String
    $attrWindow: Int
  ) {
    getSignupsV2WithEventsExport(
      campaignOrderId: $campaignOrderId
      startDate: $startDate
      endDate: $endDate
      attrMethod: $attrMethod
      attrWindow: $attrWindow
    ) {
      signUpId
      signUpDate
      totalImpressions
      lastImpression
      attrMethod
      attrValue
      attrWindow
      impressions {
        id
        eventId
        media
        impressionTime
        impressionPublisherPlatform
        impressionPublisherUrl
        impressionPublisher
        impressionPubliserViewed
        impressionPublisherMedia
      }
    }
  }
`;

export default GET_SIGNUPS_V2_WITH_EVENTS_EXPORT;
